import { render } from "./DispatchTableRow.vue?vue&type=template&id=0a0b76e7&ts=true"
import script from "./DispatchTableRow.vue?vue&type=script&lang=ts"
export * from "./DispatchTableRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__